<template>
    <div class="form-type-0">
        <form @submit.prevent="submitContactForm" @input="onInputChange" ref="form" novalidate>
            <CustomInput
                v-model="name"
                inputKey="user_name"
                type="text"
                ref="name"
                autocomplete="name"
                required
            />

            <CustomInput
                v-model="email"
                inputKey="email"
                type="email"
                ref="email"
                autocomplete="email"
                required
            />

            <CustomInput
                v-model="phone"
                inputKey="phone"
                type="text"
                ref="phone"
                autocomplete="phone"
                required
            />

            <CustomTextarea
                v-model="comment"
                inputKey="comment"
                type="comment"
                ref="comment"
            />

            <button type="submit" :disabled="loading">
                <span v-if="loading" class="loading-spinner-type-1 primary"></span>
                <span v-else>{{ $t('forms.consult_form.button') }}</span>
            </button>
            <p v-if="formError" class="form-error">{{ $t('forms.consult_form.error') }}</p>
        </form>
    </div>
</template>

<script>
    import { useUserStore } from '@/stores/user';
    import { useDatasetStore } from '@/stores/dataset';
    import formMixin from '@/mixins/formMixin';
    import CustomInput from '@/components/elements/inputs/CustomInput';
    import CustomTextarea from '@/components/elements/inputs/CustomTextarea';
    import { gaBuilderFormSubmit } from '@/utils/analytics/builder';

    export default {
        mixins: [formMixin],
        emits: ['form_submission_successful'],
        components: {
            CustomInput,
            CustomTextarea
        },
        data() {
            return {
                name: '',
                email: '',
                phone: '',
                comment: ''
            };
        },
        computed: {
            userStore() {
                return useUserStore();
            },
            datasetStore() {
                return useDatasetStore();
            }
        },
        methods: {
            async submitContactForm() {
                const form = this.$refs.form;
                if(form.checkValidity()) {
                    this.loading = true;

                    let formData = {
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        comment: this.comment
                    };

                    const success = await this.datasetStore.postContactForm(formData);
                    this.loading = false;
                    
                    if (success) {
                        if(!this.userStore.isAuthenticated) {
                            this.userStore.setUser({
                                name: this.name,
                                email: this.email,
                                phone: this.phone
                            });
                        }

                        form.reset();
                        this.formError = false;
                        this.$emit('form_submission_successful');
                        gaBuilderFormSubmit('consult', true, this.datasetStore.count || null, this.datasetStore.price || null);
                    } else {
                        this.formError = true;
                        gaBuilderFormSubmit('consult', false);
                    }
                } else {
                    this.validateAllFields();
                }
            },
            initForm() {
                if(this.userStore.user) {
                    this.name = this.userStore.user.name || '';
                    this.email = this.userStore.user.email || '';
                    this.phone = this.userStore.user.phone || '';
                }
            }
        },
        mounted() {
            this.initForm();
            this.datasetStore.refs.consultForm = this;
        },
        unmounted() {
            this.datasetStore.refs.consultForm = null;
        },
    }
</script>